module.exports = __webpack_public_path__ + "39902ce0eb1d016b4ccc1851a4bc0c2a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ice-powers.png
// module id = 2545
// module chunks = 0